import { render, staticRenderFns } from "./CardItemPerson.vue?vue&type=template&id=1a29b4db&scoped=true"
import script from "./CardItemPerson.vue?vue&type=script&lang=js"
export * from "./CardItemPerson.vue?vue&type=script&lang=js"
import style0 from "./CardItemPerson.vue?vue&type=style&index=0&id=1a29b4db&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a29b4db",
  null
  
)

export default component.exports